import styled from '@emotion/styled';
import { FlexContainer } from '../../../../../ui/containers/FlexContainer/index.ts';

export const Container = styled(FlexContainer)`
  flex-wrap: wrap;
`;
